module.exports = {"Login":"Вход","Registration":"Регистрация","Invest Ideas":"Инвестиционные идеи","Portfolio":"Мой портфель","How It Works":"Как это работает","About UT Platform":"О платформе UT","IPO":"IPO","Pre-IPO":"Pre-IPO","OTC":"OTC","Stocks and ETF":"Акции и ETF","Deposit":"Пополнить","Withdraw":"Вывести","My portfolio":"Мой портфель","Free":"Свободно","Invested":"Инвестировано","Current Profit":"Текущая прибыль","All accounts":"Все счета"}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/locales/ru/header.json
// module id = 1382
// module chunks = 118